export default async function fetchRule({ commit, rootGetters, dispatch }, ruleId) {
    try {
        commit('SET_FETCH_RULE_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const url = `/proxy/ai/classification-rules/${ruleId}?customer_id=${customer_id}`;
        const response = await window.axios.get(url);

        if (response.data.success) {
            const rule = response.data.data;
            commit('SET_RULE', rule);
        } else {
            dispatch('notifications/setError', 'Failed to fetch classification rule', { root: true });
        }
    } catch (error) {
        console.error('Error fetching classification rule:', error);
        dispatch('notifications/setError', 'Failed to fetch classification rule', { root: true });
    } finally {
        commit('SET_FETCH_RULE_LOADING', false);
    }
}